import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "../lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function ChangePasswordPage() {
    const nav = useNavigate();
    const { user, refreshMe } = useAuth();
    const [cur, setCur] = useState("");
    const [next, setNext] = useState("");
    const [confirm, setConfirm] = useState("");
    const [saving, setSaving] = useState(false);
    const forced = user?.must_change_password;

    async function submit(e) {
        e.preventDefault();
        if (next !== confirm) {
            toast.error("New passwords don't match");
            return;
        }
        if (next.length < 6) {
            toast.error("Password must be at least 6 characters");
            return;
        }
        setSaving(true);
        try {
            await api.post("/auth/change-password", { current_password: cur, new_password: next });
            toast.success("Password updated");
            await refreshMe();
            nav("/", { replace: true });
        } catch (e) {
            toast.error(apiError(e));
        } finally { setSaving(false); }
    }

    return (
        <div className="mx-auto max-w-md px-4 py-8 sm:py-14">
            <div className="rounded-xl bg-white border border-gray-100 fx-shadow-card p-6" data-testid="change-password-card">
                <div className="w-10 h-10 rounded-full bg-[#F4F6F9] text-[#1E3355] flex items-center justify-center">
                    <KeyRound className="w-5 h-5" />
                </div>
                <h1 className="font-display text-xl font-bold text-[#1E3355] mt-3">Change password</h1>
                <p className="text-sm text-gray-500 mt-1">
                    {forced ? "You must change your temporary password to continue." : "Update your account password."}
                </p>
                <form onSubmit={submit} className="mt-5 space-y-4">
                    <Field label={forced ? "Temporary password" : "Current password"}>
                        <input type="password" value={cur} onChange={(e) => setCur(e.target.value)} required className={fieldCls} data-testid="cur-password" />
                    </Field>
                    <Field label="New password">
                        <input type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={6} className={fieldCls} data-testid="new-password" />
                    </Field>
                    <Field label="Confirm new password">
                        <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={6} className={fieldCls} data-testid="confirm-password" />
                    </Field>
                    <button type="submit" disabled={saving} className="w-full bg-[#1E3355] hover:bg-[#15243C] text-white font-medium py-2.5 rounded-md transition-colors disabled:opacity-60" data-testid="change-password-submit">
                        {saving ? "Saving…" : "Update password"}
                    </button>
                </form>
            </div>
        </div>
    );
}

const fieldCls = "w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:border-[#1E3355] focus:ring-1 focus:ring-[#1E3355]";
function Field({ label, children }) {
    return (<div><label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>{children}</div>);
}
